// Display availability separately from the owned stack; never infer it from duplicates.
export const binderQuantity = (card, tradeOnly = false) => {
  if (!card || card.is_missing || card.status === "wanted") return 0;
  const owned = Math.max(0, Math.floor(Number(card.quantity ?? 1) || 0));
  return tradeOnly ? Math.min(owned, Math.max(0, Math.floor(Number(card.available_quantity) || 0))) : owned;
};
export const binderQuantityLabel = (card, tradeOnly = false) => {
  const count = binderQuantity(card, tradeOnly);
  return tradeOnly ? count + (count === 1 ? " disponible para intercambio" : " disponibles para intercambio")
    : count + (count === 1 ? " copia" : " copias");
};
